import { PROJECT_CODE } from "../../constants";
export const INNER_MINI_PROGRAM_PATHNAME = {
  Xiaoyaoxiang: "Xiaoyaoxiang",
};

export const PATHNAME_MAP_PROJECT_CODE = new Map([
  [INNER_MINI_PROGRAM_PATHNAME.Xiaoyaoxiang, PROJECT_CODE.Xiaoyaoxiang],
]);

export const PROJECT_CODE_MAP_IMAGE_LIST = new Map([
  [
    PROJECT_CODE.Xiaoyaoxiang,
    [
      "https://pub-img.treewisdomhealth.com/small-medicine-cabinet-h5-00-0828.png",
      "https://pub-img.treewisdomhealth.com/small-medicine-cabinet-h5-01-0828.png",
      "https://pub-img.treewisdomhealth.com/small-medicine-cabinet-h5-02-0828.png",
      "https://pub-img.treewisdomhealth.com/small-medicine-cabinet-h5-03-0828.png",
    ],
  ],
]);

